import { SquareM } from "lucide-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import useAuthorized from "hooks/useAuthorized";
import MetaAdAccountService from "services/MetaAdAccount";
import MetaAccountForm from "routes/meta_leads/AccountForm";
import LeadDetailPage from "routes/meta_leads/LeadDetailPage";
import ManageAccountsPage from "routes/meta_leads/ManageAccountsPage";
import MetaAccountShell from "routes/meta_leads/MetaAccountShell";

// Single source of truth for lead sources. Each descriptor is a provider
// adapter: its key doubles as the URL segment, and it carries the provider's
// own ACLs, screens, and connection lister. Adding a source is one entry here
// plus the provider's own screens under routes/<provider>/ — the routing,
// picker, nav, and sidebar all read from this list, so nothing else changes.
export const LEAD_SOURCES = [
  {
    key: "meta",
    label: "Meta",
    icon: SquareM,
    readAcl: ACL_RELATIONSHIPS.metaAdAccount.readAccounts,
    manageAcl: ACL_RELATIONSHIPS.metaAdAccount.manageAccounts,
    ManageComponent: ManageAccountsPage,
    FormComponent: MetaAccountForm,
    LeadsComponent: MetaAccountShell,
    LeadDetailComponent: LeadDetailPage,
    listConnections: MetaAdAccountService.list,
  },
];

export const getLeadSource = key =>
  LEAD_SOURCES.find(source => source.key === key) ?? null;

// Lead sources the current user may reach, filtered by the given ACL field
// ("readAcl" for viewing, "manageAcl" for connecting/editing). A single
// useAuthorized call keeps this reactive to permission changes while returning
// per-source grants in registry order.
export const useAvailableLeadSources = (aclField = "readAcl") => {
  const { grantedInfo } = useAuthorized(
    LEAD_SOURCES.map(source => source[aclField]),
    { shouldReturnGrantedInfo: true }
  );

  return LEAD_SOURCES.filter((_source, index) => grantedInfo[index]?.granted);
};
